var React = require('react');

function ButtonGroup (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"288","height":"199","fill":"white","key":0}),React.createElement("rect",{"x":"152","y":"76","width":"104","height":"48","rx":"24","fill":"#404040","key":1}),React.createElement("rect",{"x":"33","y":"77","width":"102","height":"46","rx":"23","stroke":"#404040","strokeWidth":"2","key":2})]);
}

ButtonGroup.defaultProps = {"width":"288","height":"199","viewBox":"0 0 288 199","fill":"none"};

module.exports = ButtonGroup;

ButtonGroup.default = ButtonGroup;
